import Fuse from 'fuse.js'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { Select } from 'components/Select'
import { timezones } from 'utils/timezones'

const options = {
  minMatchCharLength: 2,
  keys: [
    {
      name: 'name',
      weight: 0.3,
    },
    // Prioritize labels of additional timezones
    {
      name: 'label',
      weight: 0.7,
    },
  ],
}
const fuse = new Fuse(timezones, options)

const TimezoneSelect = ({ value, onChange, isError, hint, ...rest }) => {
  const [searchString, setSearchString] = useState(value)
  const filteredTimezones = fuse.search(searchString).map(({ item }) => ({
    label: item?.label ?? item?.name,
    value: item?.name,
  }))

  let customNoOptionsText = null
  if (searchString === '') {
    customNoOptionsText = 'Start typing for your timezone'
  }
  if (searchString !== '' && filteredTimezones.length === 0) {
    customNoOptionsText = 'No timezone found'
  }
  return (
    <Select
      hasHint
      isSearchable
      height="150px"
      label="Timezone"
      autocomplete={false}
      isError={isError}
      hint={hint}
      options={filteredTimezones}
      value={value}
      filterOption={() => true}
      customNoOptionsText={customNoOptionsText}
      onInputChange={(newSearchString) => {
        setSearchString(newSearchString)
      }}
      onChange={({ value: newValue }) => {
        onChange(newValue)
      }}
      {...rest}
    />
  )
}

TimezoneSelect.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  isError: PropTypes.bool,
  hint: PropTypes.string,
}

export default TimezoneSelect
